import React from "react";

const VimeoIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.326 6.12097C18.246 7.74817 17.1128 9.97135 14.9262 12.7972C12.6596 15.7503 10.7396 17.2235 9.17303 17.2235C8.2064 17.2235 7.37976 16.3261 6.70645 14.5248L5.3665 9.56957C4.86651 7.76826 4.3332 6.87096 3.75989 6.87096C3.63322 6.87096 3.19991 7.13211 2.45327 7.66112L1.66663 6.64328C2.4866 5.92678 3.29324 5.20358 4.09321 4.47368C5.19317 3.5228 6.01314 3.02058 6.55979 2.97371C7.85308 2.84648 8.65305 3.73039 8.95304 5.63214C9.27303 7.68121 9.49969 8.96021 9.61968 9.46243C9.993 11.1566 10.4063 12.007 10.853 12.007C11.1996 12.007 11.7263 11.4579 12.4196 10.3597C13.1196 9.26154 13.4929 8.4245 13.5395 7.84862C13.6395 6.89774 13.2662 6.42231 12.4196 6.42231C12.0263 6.42231 11.6129 6.50936 11.193 6.68346C12.0129 4.00494 13.5795 2.70585 15.8928 2.77951C17.6127 2.83308 18.4194 3.94467 18.326 6.12097Z",
  fill: "#1AB7EA"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(VimeoIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;